import { cn } from "@/dentlab/src/lib/util";
import { Archive } from "lucide-react";
import { JobDocumentWithFiles } from "@/dentlab/src/store/Jobs/job-documents.store";
import { JobDocumentTypeEnum, mapJobDocumentTypeToColor, jobDocumentTypeToTagText } from "../../job-document/job-document.types";
import { formatDate, formatCurrency } from "@/dentlab/src/lib/utils/utils-functions";
import { TooltipWrapper } from "@/dentlab/src/components/ui/tooltip-wrapper";
import { getJobDocumentIcon } from "../../job-document/job-document.component";

interface JobDocumentSidebarCollapsedItemProps {
	document: JobDocumentWithFiles;
	isSelected: boolean;
	onSelect: (documentId: number) => void;
	isArchived?: boolean;
}

export const JobDocumentSidebarCollapsedItem: React.FC<JobDocumentSidebarCollapsedItemProps> = ({
	document,
	isSelected,
	onSelect,
	isArchived,
}) => {
	const docType = document.type as JobDocumentTypeEnum;
	const color = isArchived ? "#9CA3AF" : (mapJobDocumentTypeToColor[docType] || "#797B84");
	const typeLabel = jobDocumentTypeToTagText[docType] || "Dok";

	const tooltipParts = [typeLabel];
	if (isArchived) {
		tooltipParts.unshift("Archiviert:");
	}
	if (document.date) {
		tooltipParts.push(formatDate(document.date));
	}
	if (document.amount !== null && document.amount !== undefined) {
		tooltipParts.push(formatCurrency(document.amount));
	}
	const tooltipText = tooltipParts.join(" · ");

	return (
		<TooltipWrapper title={tooltipText} position="right">
			<button
				onClick={() => onSelect(document.id)}
				className={cn(
					"w-8 h-8 flex items-center justify-center rounded transition-colors hover:bg-gray-200",
					isSelected && "ring-2 ring-blue-500"
				)}
				style={{ backgroundColor: color + "20" }}
				data-testid={`job-document-sidebar-item-icon-${document.id}`}
				aria-label={`${isArchived ? "Archiviertes " : ""}Dokument ${typeLabel} auswählen`}
				aria-selected={isSelected}
			>
				<span className="[&>svg]:h-4 [&>svg]:w-4" style={{ color }}>
					{isArchived ? <Archive /> : getJobDocumentIcon(docType)}
				</span>
			</button>
		</TooltipWrapper>
	);
};
